/**
 * t object is a singleton instance of a textHandler
 */
let textHandler = (function (Vue) {
    let t = {};

    t.system = 'dashboard';
    t.internationalization = {};
    t.notFound = '- not found -';
    t.notSpecified = '- Undefined {name} -';

    /**
     * Get by path.
     *
     * @param {string} path Uses dot-notation (section.alias).
     * @param {object} values Object-based values.
     */
    t.path = function (path, values) {
        /**
         * Initialize text values.
         */
        t.initialize();
        if (/^[^_]+$/.exec(path)) {
            path = path.replace(/\./g, '_');
        }

        return t.alias(path.toLowerCase());
    };

    /**
     * Get by alias.
     *
     * @param {string} alias
     * @param {object|null} values Object-based values.
     * @returns string
     */
    t.alias = function (alias, values = null) {
        var result = null;
        var sectionData = t.internationalization;
        alias = alias.replace(/\./g, '_').toUpperCase();

        // Find data
        if (sectionData !== null && sectionData.hasOwnProperty(alias)) {
            let textObject = sectionData[alias];
            result = textObject.content || t.notFound;
        }

        // Replace tokens.
        if (result !== null) {
            if (values !== null) {
                for (var key in values) {
                    if (values.hasOwnProperty(key)) {
                        result = result.replace('{' + key + '}', values[key]);
                    }
                }
            }
        } else {
            result = t.notFound;
        }

        return result;
    };

    /**
     * Initialize.
     * Assigning the values from the global
     */
    t.initialize = function () {
        if (Object.keys(t.internationalization).length === 0) {
            t.internationalization = Object.assign(t.internationalization, internationalization || {});
        }
    };

    window.t = t.path;
    Vue.filter('t', function (path) {
        return window.t(path);
    });
    return t;
})(Vue);
